export enum UploadFilesActions {
	UPLOAD_FILES = 'UPLOAD_FILES',
	UPLOAD_FILES_SUCCESS = 'UPLOAD_FILES_SUCCESS',
	UPLOAD_FILES_ERROR = 'UPLOAD_FILES_ERROR',
	GET_TEMP_DOCUMENT_LIST = 'GET_TEMP_DOCUMENT_LIST',
	GET_TEMP_DOCUMENT_LIST_SUCCESS = 'GET_TEMP_DOCUMENT_LIST_SUCCESS',
	GET_TEMP_DOCUMENT_LIST_ERROR = 'GET_TEMP_DOCUMENT_LIST_ERROR',
	REMOVE_TEMP_DOCUMENT = 'REMOVE_TEMP_DOCUMENT',
	REMOVE_TEMP_DOCUMENT_SUCCESS = 'REMOVE_TEMP_DOCUMENT_SUCCESS',
	REMOVE_DOCUMENT = 'REMOVE_DOCUMENT',
	REMOVE_DOCUMENT_SUCCESS = 'REMOVE_DOCUMENT_SUCCESS',
	GET_DOCUMENT_LIST = 'GET_DOCUMENT_LIST',
	GET_DOCUMENT_LIST_SUCCESS = 'GET_DOCUMENT_LIST_SUCCESS',
	GET_DOCUMENT_LIST_ERROR = 'GET_DOCUMENT_LIST_ERROR',
	DOWNLOAD_FILE = 'DOWNLOAD_FILE',
	DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS',
	DOWNLOAD_FILE_ERROR = 'DOWNLOAD_FILE_ERROR'
}

export enum HeaderDataValidationActions {
	GET_VALIDATIONS = 'GET_VALIDATIONS',
	GET_VALIDATIONS_SUCCESS = 'GET_VALIDATIONS_SUCCESS',
	CONFIRM_VALIDATIONS = 'CONFIRM_VALIDATIONS',
	CONFIRM_VALIDATIONS_SUCCESS = 'CONFIRM_VALIDATIONS_SUCCESS'
}

export enum CalculationBonusesActions {
	GET_BONUSES = 'GET_BONUSES',
	GET_BONUSES_SUCCESS = 'GET_BONUSES_SUCCESS',
	CONFIRM_BONUSES = 'CONFIRM_BONUSES',
	CONFIRM_BONUSES_SUCCESS = 'CONFIRM_BONUSES_SUCCESS'
}

export enum HeaderEntryActions {
	GET_FORM_ATTRIBUTES = 'GET_FORM_ATTRIBUTES',
	GET_FORM_ATTRIBUTES_SUCCESS = 'GET_FORM_ATTRIBUTES_SUCCESS',
	CONFIRM_ATTRIBUTES = 'CONFIRM_HEADER_ATTRIBUTES',
	CONFIRM_ATTRIBUTES_SUCCESS = 'CONFIRM_HEADER_ATTRIBUTES_SUCCESS'
}

export enum InventoryPickStockActions {
	INVENTORY_PICK_BAR_CODE_SEARCH = 'INVENTORY_PICK_BAR_CODE_SEARCH',
	INVENTORY_PICK_BAR_CODE_SEARCH_SUCCESS = 'INVENTORY_PICK_BAR_CODE_SEARCH_SUCCESS',
	INVENTORY_PICK_BAR_CODE_SEARCH_ERROR = 'INVENTORY_PICK_BAR_CODE_SEARCH_ERROR',
	GET_INVENTORY_PICK_STOCK = 'GET_INVENTORY_PICK_STOCK',
	GET_INVENTORY_PICK_STOCK_SUCCESS = 'GET_INVENTORY_PICK_STOCK_SUCCESS',
	GET_CUF_PICK_STOCK = 'GET_CUF_PICK_STOCK',
	GET_CUF_PICK_STOCK_SUCCESS = 'GET_CUF_PICK_STOCK_SUCCESS',
	GET_DEPOSITS_PICK_STOCK = 'GET_DEPOSITS_PICK_STOCK',
	GET_DEPOSITS_PICK_STOCK_SUCCESS = 'GET_DEPOSITS_PICK_STOCK_SUCCESS',
	CONFIRM_INVENTORY_PICK_STOCK = 'CONFIRM_INVENTORY_PICK_STOCK',
	CONFORM_INVENTORY_PICK_STOCK_SUCCESS = 'CONFORM_INVENTORY_PICK_STOCK_SUCCESS'
}

export enum InventoryExpensesStockActions {
	INVENTORY_PICK_BAR_CODE_SEARCH = 'INVENTORY_PICK_BAR_CODE_SEARCH',
	INVENTORY_PICK_BAR_CODE_SEARCH_SUCCESS = 'INVENTORY_PICK_BAR_CODE_SEARCH_SUCCESS',
	INVENTORY_PICK_BAR_CODE_SEARCH_ERROR = 'INVENTORY_PICK_BAR_CODE_SEARCH_ERROR',
	GET_INVENTORY_PICK_STOCK = 'GET_INVENTORY_PICK_STOCK',
	GET_INVENTORY_PICK_STOCK_SUCCESS = 'GET_INVENTORY_PICK_STOCK_SUCCESS',
	GET_CUF_PICK_EXPENSES = 'GET_CUF_PICK_EXPENSES',
	GET_CUF_PICK_EXPENSES_SUCCESS = 'GET_CUF_PICK_EXPENSES_SUCCESS',
	GET_DEPOSITS_PICK_EXPENSES = 'GET_DEPOSITS_PICK_EXPENSES',
	GET_DEPOSITS_PICK_EXPENSES_SUCCESS = 'GET_DEPOSITS_PICK_EXPENSES_SUCCESS',
	CONFIRM_INVENTORY_PICK_STOCK = 'CONFIRM_EXPENSES_INVENTORY_PICK_STOCK',
	CONFIRM_INVENTORY_PICK_STOCK_SUCCESS = 'CONFIRM_EXPENSES_INVENTORY_PICK_STOCK_SUCCESS'
}

export enum LoadPackageActions {
	GET_PACKAGES = 'GET_PACKAGES',
	GET_PACKAGES_SUCCESS = 'GET_PACKAGES_SUCCESS',
	GET_PACKAGES_ERROR = 'GET_PACKAGES_ERROR',
	CONFIRM_PACKAGES = 'CONFIRM_PACKAGES',
	CONFIRM_PACKAGES_SUCCESS = 'CONFIRM_PACKAGES_SUCCESS',
	CONFIRM_PACKAGES_ERROR = 'CONFIRM_PACKAGES_ERROR'
}

export enum LoadInventoryItemsActions {
	LOAD_ITEM_INVENTORY = 'LOAD_ITEM_INVENTORY',
	LOAD_ITEM_INVENTORY_SUCCESS = 'LOAD_ITEM_INVENTORY_SUCCESS',
	LOAD_ITEM_INVENTORY_ERROR = 'LOAD_ITEM_INVENTORY_ERROR',
	LOAD_ITEM_INCOME_INVENTORY = 'LOAD_ITEM_INCOME_INVENTORY',
	LOAD_ITEM_INCOME_INVENTORY_SUCCESS = 'LOAD_ITEM_INCOME_INVENTORY_SUCCESS',
	LOAD_ITEM_INCOME_INVENTORY_ERROR = 'LOAD_ITEM_INCOME_INVENTORY_ERROR',
	LOAD_ITEM_INVENTORY_CONFIRM = 'LOAD_ITEM_INVENTORY_CONFIRM',
	LOAD_ITEM_INVENTORY_CONFIRM_SUCCESS = 'LOAD_ITEM_INVENTORY_CONFIRM_SUCCESS',
	LOAD_ITEM_INVENTORY_CONFIRM_ERROR = 'LOAD_ITEM_INVENTORY_CONFIRM_ERROR',
	FORM_LOAD_ITEM_INVENTORY = 'FORM_LOAD_ITEM_INVENTORY',
	FORM_LOAD_INCOME_ITEM_INVENTORY = 'FORM_LOAD_INCOME_ITEM_INVENTORY',
	FORM_LOAD_ITEM_FORM = 'LOAD_ITEM',
	FORM_LOAD_ITEM_PROVIDER = 'FORM_LOAD_ITEM_PROVIDER'
}

export enum TreasuryHeaderActions {
	GET_ATTRIBUTES_TREASURY_HEADER = 'GET_ATTRIBUTES_TREASURY_HEADER',
	GET_ATTRIBUTES_TREASURY_HEADER_SUCCESS = 'GET_ATTRIBUTES_TREASURY_HEADER_SUCCESS',
	GET_ATTRIBUTES_TREASURY_HEADER_ERROR = 'GET_ATTRIBUTES_TREASURY_HEADER_ERROR',
	CONFIRM_ATTRIBUTES_TREASURY_HEADER = 'CONFIRM_ATTRIBUTES_TREASURY_HEADER',
	CONFIRM_ATTRIBUTES_TREASURY_HEADER_SUCCESS = 'CONFIRM_ATTRIBUTES_TREASURY_HEADER_SUCCESS',
	CONFIRM_ATTRIBUTES_TREASURY_HEADER_ERROR = 'CONFIRM_ATTRIBUTES_TREASURY_HEADER_ERROR',
	GET_TREASURY_CURRENCIES = 'GET_TREASURY_CURRENCIES',
	GET_TREASURY_CURRENCIES_SUCCESS = 'GET_TREASURY_CURRENCIES_SUCCESS',
	GET_TREASURY_CURRENCIES_ERROR = 'GET_TREASURY_CURRENCIES_ERROR'
}

export enum IndividualTreasuryItemActions {
	LOADING_TREASURY_ITEM = 'LOADING_TREASURY_ITEM',
	LOADING_TREASURY_ITEM_SUCCESS = 'LOADING_TREASURY_ITEM_SUCCESS',
	LOADING_TREASURY_ITEM_ERROR = 'LOADING_TREASURY_ITEM_ERROR',
	GET_TREASURY_PRODUCT_DATA = 'GET_TREASURY_PRODUCT_DATA',
	GET_TREASURY_PRODUCT_DATA_SUCCESS = 'GET_TREASURY_PRODUCT_DATA_SUCCESS',
	GET_TREASURY_PRODUCT_DATA_ERROR = 'GET_TREASURY_PRODUCT_DATA_ERROR',
	UPDATE_TREASURY_PRODUCT_DATA = 'UPDATE_TREASURY_PRODUCT_DATA',
	UPDATE_TREASURY_PRODUCT_DATA_SUCCESS = 'UPDATE_TREASURY_PRODUCT_DATA_SUCCESS',
	UPDATE_TREASURY_PRODUCT_DATA_ERROR = 'UPDATE_TREASURY_PRODUCT_DATA_ERROR',
	CONFIRM_TREASURY_ITEM_PRODUCT = 'CONFIRM_TREASURY_ITEM_PRODUCT',
	CONFIRM_TREASURY_ITEM_PRODUCT_SUCCESS = 'CONFIRM_TREASURY_ITEM_PRODUCT_SUCCESS',
	CONFIRM_TREASURY_ITEM_PRODUCT_ERROR = 'CONFIRM_TREASURY_ITEM_PRODUCT_ERROR'
}

export enum ProductImportActions {
	IMPORT_PRODUCTS = 'IMPORT_PRODUCTS',
	IMPORT_PRODUCTS_ERROR = 'IMPORT_PRODUCTS_ERROR',
	IMPORT_PRODUCTS_SUCCESS = 'IMPORT_PRODUCTS_SUCCESS',
	CLEAR_IMPORT_PRODUCTS = 'CLEAR_IMPORT_PRODUCT',
	CONFIRM_IMPORT_PRODUCTS = 'CONFIRM_IMPORT_PRODUCTS',
	CONFIRM_IMPORT_PRODUCTS_ERROR = 'CONFIRM_IMPORT_PRODUCTS_ERROR',
	CONFIRM_IMPORT_PRODUCTS_SUCCESS = 'CONFIRM_IMPORT_PRODUCTS_SUCCESS',
	IMPORT_PRODUCTS_TABLE_PAGINATION = 'IMPORT_PRODUCTS_TABLE_PAGINATION',
	IMPORT_PRODUCTS_TABLE_PAGINATION_SUCCESS = 'IMPORT_PRODUCTS_TABLE_PAGINATION_SUCCESS',
	IMPORT_PRODUCTS_TABLE_PAGINATION_ERROR = 'IMPORT_PRODUCTS_TABLE_PAGINATION_ERROR'
}

export enum ElectronicReceiptsActions {
	GET_ELECTRONIC_RECEIPTS_HEADERS = 'GET_ELECTRONIC_RECEIPTS_HEADERS',
	GET_ELECTRONIC_RECEIPTS_HEADERS_SUCCESS = 'GET_ELECTRONIC_RECEIPTS_HEADERS_SUCCESS',
	CONFIRM_ELECTRONIC_RECEIPTS_HEADERS = 'CONFIRM_ELECTRONIC_RECEIPTS_HEADERS',
	CONFIRM_ELECTRONIC_RECEIPTS_HEADERS_SUCCESS = 'CONFIRM_ELECTRONIC_RECEIPTS_HEADERS_SUCCESS',
	CONFIRM_ELECTRONIC_RECEIPTS_HEADERS_ERROR = 'CONFIRM_ELECTRONIC_RECEIPTS_HEADERS_ERROR',
	SET_ELECTRONIC_RECEIPTS_HEADER_FILTERS = 'SET_ELECTRONIC_RECEIPTS_HEADER_FILTERS',
	CLEAR_ELECTRONIC_RECEIPTS_HEADER_FILTERS = 'CLEAR_ELECTRONIC_RECEIPTS_HEADER_FILTERS',
	VALIDATE_ELECTRONIC_RECEIPTS = 'VALIDATE_ELECTRONIC_RECEIPTS',
	VALIDATE_ELECTRONIC_RECEIPTS_SUCCESS = 'VALIDATE_ELECTRONIC_RECEIPTS_SUCCESS',
	VALIDATE_ELECTRONIC_RECEIPTS_ERROR = 'VALIDATE_ELECTRONIC_RECEIPTS_ERROR',
	CONSULT_ELECTRONIC_RECEIPTS = 'CONSULT_ELECTRONIC_RECEIPTS',
	CONSULT_ELECTRONIC_RECEIPTS_SUCCESS = 'CONSULT_ELECTRONIC_RECEIPTS_SUCCESS',
	CONSULT_ELECTRONIC_RECEIPTS_ERROR = 'CONSULT_ELECTRONIC_RECEIPTS_ERROR',
	CANCEL_ELECTRONIC_RECEIPTS = 'CANCEL_ELECTRONIC_RECEIPTS',
	CANCEL_ELECTRONIC_RECEIPTS_SUCCESS = 'CANCEL_ELECTRONIC_RECEIPTS_SUCCESS',
	CANCEL_ELECTRONIC_RECEIPTS_ERROR = 'CANCEL_ELECTRONIC_RECEIPTS_ERROR'
}

export enum SalesMonitorActions {
	GET_ZONES = 'GET_ZONES',
	GET_ZONES_SUCCESS = 'GET_ZONES_SUCCESS',
	GET_ZONES_ERROR = 'GET_ZONES_ERROR',
	GET_SALES_MONITOR_ITEMS = 'GET_SALES_MONITOR_ITEMS',
	GET_SALES_MONITOR_ITEMS_ERROR = 'GET_SALES_MONITOR_ITEMS_ERROR',
	GET_SALES_MONITOR_ITEMS_SUCCESS = 'GET_SALES_MONITOR_ITEMS_SUCCESS',
	CONFIRM_SALES_MONITOR = 'CONFIRM_SALES_MONITOR',
	CONFIRM_SALES_MONITOR_ERROR = 'CONFIRM_SALES_MONITOR_ERROR',
	CONFIRM_SALES_MONITOR_SUCCESS = 'CONFIRM_SALES_MONITOR_SUCCESS',
	VALIDATE_BAR_CODE_MONITOR = 'VALIDATE_BAR_CODE_MONITOR',
	VALIDATE_BAR_CODE_MONITOR_SUCCESS = 'VALIDATE_BAR_CODE_MONITOR_SUCCESS',
	VALIDATE_BAR_CODE_MONITOR_ERROR = 'VALIDATE_BAR_CODE_MONITOR_ERROR',
	SELECT_SALES_MONITOR_ITEMS = 'SELECT_SALES_MONITOR_ITEMS',
	SELECT_SALES_MONITOR_ITEMS_SUCCESS = 'SELECT_SALES_MONITOR_ITEMS_SUCCESS',
	SELECT_SALES_MONITOR_ITEMS_ERROR = 'SELECT_SALES_MONITOR_ITEMS_ERROR'
}

export enum ActivationMissingActions {
	GET_ACTIVATION_MISSING_ORDERS = 'GET_ACTIVATION_MISSING_ORDERS',
	GET_ACTIVATION_MISSING_ORDERS_ERROR = 'GET_ACTIVATION_MISSING_ORDERS_ERROR',
	GET_ACTIVATION_MISSING_ORDERS_SUCCESS = 'GET_ACTIVATION_MISSING_ORDERS_SUCCESS',
	SELECT_ACTIVATION_MISSING_ITEM = 'SELECT_ACTIVATION_MISSING_ITEM',
	SELECT_ACTIVATION_MISSING_ITEM_ERROR = 'SELECT_ACTIVATION_MISSING_ITEM_ERROR',
	SELECT_ACTIVATION_MISSING_ITEM_SUCCESS = 'SELECT_ACTIVATION_MISSING_ITEM_SUCCESS',
	CONFIRM_ACTIVATION_MISSING_ITEMS = 'CONFIRM_ACTIVATION_MISSING_ITEMS',
	CONFIRM_ACTIVATION_MISSING_ITEMS_ERROR = 'CONFIRM_ACTIVATION_MISSING_ITEMS_ERROR',
	CONFIRM_ACTIVATION_MISSING_ITEMS_SUCCESS = 'CONFIRM_ACTIVATION_MISSING_ITEMS_SUCCESS',
	CONFIRM_ACTIVATION_MISSING_STATUS = 'CONFIRM_ACTIVATION_MISSING_STATUS',
	CONFIRM_ACTIVATION_MISSING_STATUS_SUCCESS = 'CONFIRM_ACTIVATION_MISSING_STATUS_SUCCESS',
	CONFIRM_ACTIVATION_MISSING_STATUS_CLEAR = 'CONFIRM_ACTIVATION_MISSING_STATUS_CLEAR',
	CANCEL_ACTIVATION_MISSING = 'CANCEL_ACTIVATION_MISSING',
	CANCEL_ACTIVATION_MISSING_SUCCESS = 'CANCEL_ACTIVATION_MISSING_SUCCESS'
}

// TableModalActions

export enum TableModalActions {
	GET_TABLE_MODAL_DATA = 'GET_TABLE_MODAL_DATA',
	GET_TABLE_MODAL_DATA_SUCCESS = 'GET_TABLE_MODAL_DATA_SUCCESS',
	GET_TABLE_MODAL_PAGINATION = 'GET_TABLE_MODAL_PAGINATION',
	GET_TABLE_MODAL_PAGINATION_SUCCESS = 'GET_TABLE_MODAL_PAGINATION_SUCCESS',
	SELECT_TABLE_MODAL_DATA = 'SELECT_TABLE_MODAL_DATA',
	SELECT_TABLE_MODAL_DATA_SUCCESS = 'SELECT_TABLE_MODAL_DATA_SUCCESS',
	SELECT_ALL_TABLE_MODAL_DATA = 'SELECT_ALL_TABLE_MODAL_DATA',
	SELECT_ALL_TABLE_MODAL_DATA_SUCCESS = 'SELECT_ALL_TABLE_MODAL_DATA_SUCCESS',
	CONFIRM_TABLE_MODAL_DATA = 'CONFIRM_TABLE_MODAL_DATA',
	CONFIRM_TABLE_MODAL_DATA_SUCCESS = 'CONFIRM_TABLE_MODAL_DATA_SUCCESS'
}

export enum PurchasesAttributesActions {
	GET_ATTRIBUTES = 'GET_ATTRIBUTES',
	GET_ATTRIBUTES_SUCCESS = 'GET_ATTRIBUTES_SUCCESS',
	CONFIRM_ATTRIBUTES = 'CONFIRM_ATTRIBUTES',
	CONFIRM_ATTRIBUTES_SUCCESS = 'CONFIRM_ATTRIBUTES_SUCCESS',
	CANCEL_ATTRIBUTES = 'CANCEL_ATTRIBUTES',
	CANCEL_ATTRIBUTES_SUCCESS = 'CANCEL_ATTRIBUTES_SUCCESS',
	GET_PURCHASES_ATTRIBUTES = 'GET_PURCHASES_ATTRIBUTES',
	GET_PURCHASES_ATTRIBUTES_SUCCESS = 'GET_PURCHASES_ATTRIBUTES_SUCCESS',
	CANCEL_PURCHASES_ATTRIBUTES = 'CANCEL_PURCHASES_ATTRIBUTES',
	CANCEL_PURCHASES_ATTRIBUTES_SUCCESS = 'CANCEL_PURCHASES_ATTRIBUTES_SUCCESS',
	CONFIRM_PURCHASES_ATTRIBUTES = 'CONFIRM_PURCHASES_ATTRIBUTES',
	CONFIRM_PURCHASES_ATTRIBUTES_SUCCESS = 'CONFIRM_PURCHASES_ATTRIBUTES_SUCCESS'
}
